import { create } from "zustand";

const useJobTypeStore = create((set) => ({
    jobTypes: [], //jobtypes
    setJobTypes: (value) => set((state) => ({...state, jobTypes: value}))
}));

export default useJobTypeStore;
